import { useMutation } from "@tanstack/react-query";

const API = process.env.REACT_APP_API;

const useSendResetPasswordEmail = () => {
  const mutationFn = async (email: string) => {
    const response = await fetch(
      `${API}/api/feira_online/password_reset_request`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      },
    );

    if (!response.ok) {
      throw response;
    }

    return await response.json();
  };

  return useMutation({
    mutationFn,
  });
};

export default useSendResetPasswordEmail;
